import { render, staticRenderFns } from "./RateTaxPersonModal.vue?vue&type=template&id=0841181c&scoped=true&"
import script from "./RateTaxPersonModal.vue?vue&type=script&lang=js&"
export * from "./RateTaxPersonModal.vue?vue&type=script&lang=js&"
import style0 from "./RateTaxPersonModal.vue?vue&type=style&index=0&id=0841181c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0841181c",
  null
  
)

component.options.__file = "RateTaxPersonModal.vue"
export default component.exports